import { combineReducers } from 'redux';

// interfaces
import { ILogin } from '../model/login';
import { ISubscriptionReportState } from '../model/subscriptionReports';
import { IProductionReportsState } from '../model/productionReports';
import { IProductionSpeedState } from '../model/productionSpeed';
import { IEnclosurePOState } from '../model/enclosurePO';
import { IAll41ProjectsState } from '../model/all41Projects';
import { IOpenModsReportState } from '../model/openModsReport';
import { ILoaderState } from './loading/loading'

// reducers
import { loginReducer } from './login/reducer';
import { supscriptionReportsReducer } from './subscriptionReports/reducer';
import { productionReportReducer } from './productionReports/reducer';
import { productionSpeedReducer } from './productionSpeed/reducer';
import { enclosurePOReducer } from './enclosurePO/reducer';
import { all41ProjectsReducer } from './all41Projects/reducer';
import { openModsReportReducer } from './openModsReport/reducer'
import { loadingReducer } from './loading/loading'

export interface IReportsState {
  subscriptionReports: ISubscriptionReportState[];
  productionReports: IProductionReportsState[];
  productionSpeed: IProductionSpeedState[];
  enclosurePO: IEnclosurePOState[];
  all41Project: IAll41ProjectsState[];
  openModsReport: IOpenModsReportState[];
  loading: ILoaderState[];
  loginUser: ILogin[];
};

export const state = combineReducers<any>({
  subscriptionReports: supscriptionReportsReducer,
  productionReports: productionReportReducer,
  productionSpeed: productionSpeedReducer,
  enclosurePO: enclosurePOReducer,
  all41Projects: all41ProjectsReducer,
  openModsReport: openModsReportReducer,
  loading: loadingReducer,
  loginUser: loginReducer,
});


// WEBPACK FOOTER //
// ./src/store/index.ts